/**
 * Convert an ISO 3166-1 alpha-2 country code to its emoji flag.
 * e.g. "TR" → "🇹🇷", "US" → "🇺🇸"
 */
export function countryCodeToFlag(code: string): string {
  return code
    .toUpperCase()
    .split('')
    .map((char) => String.fromCodePoint(0x1f1e6 + char.charCodeAt(0) - 65))
    .join('')
}
